module.exports = __webpack_public_path__ + "static/media/marker-user.82234d1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/marker-user.svg
// module id = 177
// module chunks = 0